import CALENDAR from '../assets/images/calendar.svg';
import SUNDIAL from '../assets/images/sundial.svg';

export const CALENDAR_ICON = CALENDAR;
export const SUNDIAL_ICON = SUNDIAL;
